import { isNullOrUndefined } from "@/utils/guards";
import type { TResponseGetDealFiles } from "@/apis/odin/apiODIN";

export const createSelectorFilteredDealFiles = (state: {
    dealFiles: TResponseGetDealFiles["files"];
}): TResponseGetDealFiles["files"] => {
    const { dealFiles } = state;
    return dealFiles.map(file => {
        return {
            ...file,
            extractions: file.extractions.filter(extraction => {
                return isNullOrUndefined(extraction.deletedAt);
            }),
        };
    });
};
